import React, { useContext, useEffect, useState } from 'react';
import styles from './PermissionModal.module.css';
import ModalShell from 'components/shared/modal/ModalShell';
import ModalContext from 'config/context/modalContext';
import useTheme from 'config/useTheme';
import { useDeletePermission } from 'api/permissions/usePermissions';
import PreExecutionConfirmation from './PreExecutionConfirmation';
import SuccessfullActionModal from './SuccessfullActionModal';
import Loader from 'components/shared/loader/Loader';
import PrivateKeyField from 'components/shared/private-key-field/PrivateKeyField';

const DeletePermissionModal = ({ permissionName, finalStepDuration, permissionParentName }) => {
    const { dark } = useTheme();
    const { handleModal } = useContext(ModalContext);
    const [step, setStep] = useState(1);
    const [confirmed, setConfirmed] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [data, setData] = useState({
        permission_name: permissionName,
        permission_parent_private_key: ''
    });

    const {
        response,
        loading,
        error,
        deletePermission,
        resetServerStatus
    } = useDeletePermission({
        permissionName: data?.permission_name,
        permissionParentPrivateKey: data?.permission_parent_private_key
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    useEffect(() => {
        if (!data.permission_name || !data.permission_parent_private_key) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    }, [data]);

    const handleDeletePermission = () => {
        deletePermission();
    }

    useEffect(() => {
        if (step === 2) {
            if (confirmed) {
                setStep(3);
            }
        }

        if (step === 3) {
            handleDeletePermission();
            setStep(4);
        }

        if (step === 4 && !loading) {
            if (response?.status) {
                setStep(5);
                setTimeout(() => {
                    resetServerStatus();
                    setConfirmed(false);
                    handleModal(false);
                    window.location.reload();
                }, finalStepDuration || 1600);
            }

            if (!response?.status || error) {
                setStep(1);
            }
        }

    }, [step, confirmed, response?.status, error, loading]);


    if (step === 1) {
        return (
            <ModalShell closeOnOverlay={true}>
                <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
                    <div className={styles.label}>Delete permission</div>
                    <form >
                        <div className={styles.input_group}>
                            <p>"{permissionParentName}" permission private key</p>
                            <div className={styles.input_block}>
                                <PrivateKeyField
                                    name='permission_parent_private_key'
                                    value={data.permission_parent_private_key}
                                    onChange={handleInputChange}
                                    placeholder="Private key"
                                />
                            </div>
                        </div>
                    </form>
                    {error && <div className={styles.form_msg}><span>{error}</span></div>}
                    <div className={styles.form_actions}>
                        <button
                            disabled={!isValid}
                            onClick={() => setStep(2)}
                        >
                            Delete
                        </button>
                        <button onClick={() => handleModal(false)}>Cancel</button>
                    </div>
                </div>
            </ModalShell>
        );
    }

    if (step === 2) {
        return (
            <ModalShell>
                <PreExecutionConfirmation
                    actionName={"DELETE PERMISSION"}
                    setConfirmation={setConfirmed}
                    handleModal={handleModal}
                />
            </ModalShell>
        );
    }

    if (step === 4 && loading) {
        return (
            <ModalShell>
                <Loader />
            </ModalShell>
        );
    }

    if (step === 5) {
        return (
            <ModalShell>
                <SuccessfullActionModal message={response?.message} />
            </ModalShell>
        );
    }

}

export default DeletePermissionModal;